<template>
  <EditorPanel title="Crear una nueva tarjeta" :loading-save="loadingSave" @confirm="addNewCard">
    <div class="d-flex flex-column" style="gap: 12px;">
      <EditorRowGroup label="Tamaño:">
        <v-select v-model="size" :items="sizes" item-text="name" item-value="value" outlined hide-details="auto" dense
          color="#9BA9BD" class="editor-select--compact rounded-lg m-0 p-0" />
      </EditorRowGroup>

      <EditorRowGroup v-if="selectedLayout === 'grid'" label="Posicion:">
        <v-select v-model="position" :items="positions" item-text="name" item-value="value" outlined hide-details="auto"
          dense color="#9BA9BD" :disabled="true" class="editor-select--compact rounded-lg m-0 p-0" />
      </EditorRowGroup>
    </div>
  </EditorPanel>
</template>

<script>
import EditorPanel from './EditorPanel.vue'
import EditorRowGroup from './shared/EditorRowGroup.vue'
export default {
  name: 'EditorAddCardPanel',
  components: { EditorPanel, EditorRowGroup },
  props: {
    loadingSave: {
      type: Boolean,
      default: false
    },
    selectedLayout: {
      type: String,
      default: 'grid'
    }
  },
  data() {
    return {
      size: 'small',
      position: 'left',
      sizes: [
        { name: 'Pequeño', value: 'small' },
        { name: 'Mediano', value: 'medium' },
        { name: 'Grande', value: 'large' }
      ],
      positions: [
        { name: 'Izquierda', value: 'left' },
        { name: 'Derecha', value: 'right' }
      ]
    }
  },
  methods: {
    addNewCard() {
      this.$emit('add-card', {
        size: this.size,
        position: this.position
      })
    }
  }
}
</script>

<style scoped>
@import './editor-panel.css';
</style>
